import { useCallback } from 'react';
import Button from '@mui/material/Button';

import { getLabelMessage } from '@gef-ui/localization/messages';
import Print from '@gef-ui/material-icons/Print';

export const ActionButtons = () => {
	const handlePrint = useCallback(() => {
		window.print();
	}, []);

	return (
		<Button variant="text" startIcon={<Print />} onClick={handlePrint}>
			{getLabelMessage('common:print')}
		</Button>
	);
};

export default ActionButtons;
